module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Forum"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Forums for sharing and helping each other'),
      expression: "'Forums for sharing and helping each other'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(!_vm.results.topics || _vm.noResults) ? _c('div', {
    staticClass: "forums"
  }, [(_vm.subforums) ? _c('ul', {
    staticClass: "threads clearfix"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.subforums), function(subforum) {
    return _c('li', {
      staticClass: "row thread clearfix"
    }, [_c('div', {
      staticClass: "col-xs-2 col-md-2 forum-image"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'discussion',
          params: {
            forumId: subforum.id
          }
        }
      }
    }, [(subforum.image) ? _c('img', {
      attrs: {
        "src": subforum.image
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../assets/img/ttto-thumbnail.jpg")
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-md-4 forum-link"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'discussion',
          params: {
            forumId: subforum.id
          }
        }
      }
    }, [_c('h4', [_vm._v(_vm._s(subforum.title))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 col-md-2 stats-wrapper"
    }, [_vm._v("\n                        " + _vm._s(subforum.topic_count) + " Threads"), _c('br'), _vm._v("\n                        " + _vm._s(subforum.post_count) + " Posts\n                    ")]), _vm._v(" "), (subforum.latestPost) ? _c('div', {
      staticClass: "col-xs-4 col-md-4 last-post-wrapper"
    }, [_c('span', {
      staticClass: "last-post"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'thread',
          params: {
            forumId: subforum.id,
            topicId: subforum.latestPost.thread,
            postId: subforum.latestPost.id
          }
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm._f("truncate")(subforum.latestPost.title, 35))), _c('br')])], 1), _vm._v("\n                            by:\n                         "), _c('span', {
      staticClass: "post-author-link "
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'posts-by-user',
          query: {
            userId: subforum.latestPost.userId
          }
        }
      }
    }, [_c('img', {
      staticClass: "role-icon",
      attrs: {
        "src": _vm._f("roleIcon")(subforum.latestPost.roles, subforum.latestPost.terms)
      }
    }), _vm._v("\n\n                                 " + _vm._s(subforum.latestPost.name)), _c('br')])], 1), _vm._v("\n                            " + _vm._s(_vm._f("timeago")(subforum.latestPost.createdAt)) + "\n\n                    ")]) : _vm._e()])
  })], 2) : _vm._e()]) : _c('div', {
    staticClass: "search-results"
  }, [((_vm.results.topics || _vm.results.posts) && (_vm.results.topics.length > 0 || _vm.results.posts.length > 0)) ? _c('ul', {
    staticClass: "list-group results"
  }, [_vm._l((_vm.results.topics), function(topic) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'thread',
          params: {
            forumId: topic.subforumId,
            topicId: topic.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "topiced-at"
    }, [_vm._v(_vm._s(_vm._f("shortDate")(topic.createdAt)))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(topic.title)
      }
    })])], 1)
  }), _vm._v(" "), _vm._l((_vm.results.posts), function(post) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_vm._v("\n                " + _vm._s(post) + "\n                    "), _c('router-link', {
      attrs: {
        "to": {
          name: 'thread',
          params: {
            forumId: post.forumId,
            topicId: post.topicId
          }
        }
      }
    }, [_c('span', {
      staticClass: "posted-at"
    }, [_vm._v(_vm._s(_vm._f("shortDate")(post.createdAt)))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(post.ts_headline)
      }
    })])], 1)
  })], 2) : _c('div', {
    staticClass: "no-results"
  }, [_vm._v("No results found")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "clearfix forum-header"
  }, [_c('div', {
    staticClass: "col-xs-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 title-header"
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_vm._v("Statistics")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_vm._v("Last Post")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-312c6087!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Forum.vue
// module id = 1986
// module chunks = 2